import { OperationDirection, TransactionTabName } from './Transactions.types';
import { formatNumber } from '@/utils/helpers';

export function formatOperationAmount(
  amount: number,
  direction: OperationDirection,
  currency?: string
): string {
  const sign = direction === OperationDirection.Income ? '' : '−';
  const formatted = formatNumber(amount, currency ? 2 : 0);

  if (!currency) {
    return `${sign}${formatted}`;
  }

  return `${sign}${formatted} ${currency}`;
}

export function getActiveTab(
  hash: string | undefined,
  isShop: boolean
): TransactionTabName {
  if (hash === TransactionTabName.Ads) {
    return TransactionTabName.Ads;
  }

  if (hash === TransactionTabName.PaidAds && isShop) {
    return TransactionTabName.PaidAds;
  }

  return TransactionTabName.Account;
}
